<template>
  <base-layout>
    <div style="height: 100%;">
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-2">
        </div>
        <div class="col-md-8 pL0">
          <ul class="clearfix list-unstyled list-inline" style="margin-bottom:0px !important;">
            <ul class="clearfix list-unstyled list-inline pull-left">
              <li><h3 style="color: rgb(25, 34, 71); font-weight: 600;padding-left:10px;top:20px;">Notifications</h3></li><span class="span-color" v-if="notificationCount != 0">{{notificationCount}}</span>
            </ul>
            <ul class="pull-right clearfix list-unstyled list-inline">
              <li><a @click="markAllRead" class="mark_all_read" v-if="hasUnreadNotification">Mark All Read</a></li>
            </ul>
          </ul>
        </div>
        <div class="col-md-1"></div>
      </div>
      <div class="Notification">
        <ob-layout :type="13">
          <template slot="left-section">
            <!-- Nav tabs -->
            <div class="NotificationTabs">
              <!-- 'tabs-right' for right tabs -->
              <li :class="{'active': filterType == 'Today'}" @click="filterType = 'Today'">
                <a href="javascript:;" class="filter_type">Today</a>
              </li>
              <li :class="{'active': filterType == 'CurrentWeek'}" @click="filterType = 'CurrentWeek'">
                <a href="javascript:;" class="filter_type">This Week</a>
              </li>
              <li :class="{'active': filterType == 'CurrentMonth'}" @click="filterType = 'CurrentMonth'">
                <a href="javascript:;" class="filter_type">This Month</a>
              </li>
              <li :class="{'active': filterType == 'PreviousMonth'}" @click="filterType = 'PreviousMonth'">
                <a href="javascript:;" class="filter_type">{{previousMonthLabel}}</a>
              </li>
              <li :class="{'active': filterType == 'PreviousMonth1'}" @click="filterType = 'PreviousMonth1'">
                <a href="javascript:;" class="filter_type">{{previousMonth1Label}}</a>
              </li>
              <li :class="{'active': filterType == 'PastSixMonths'}" @click="filterType = 'PastSixMonths'">
                <a href="javascript:;" class="filter_type">Past 6 Months</a>
              </li>
              <li :class="{'active': filterType == 'CurrentYear'}"  @click="filterType = 'CurrentYear'">
                <a href="javascript:;" class="filter_type">This Year</a>
              </li>
              <li :class="{'active': filterType == 'PreviousYear'}" @click="filterType = 'PreviousYear'">
                <a href="javascript:;" class="filter_type">{{previousYearLabel}}</a>
              </li>
              <li :class="{'active': filterType == 'PreviousYear1'}" @click="filterType = 'PreviousYear1'">
                <a href="javascript:;" class="filter_type">{{previousYear1Label}}</a>
              </li>
              <li :class="{'active': filterType == 'PreviousYear2'}" @click="filterType = 'PreviousYear2'">
                <a href="javascript:;" class="filter_type">{{previousYear2Label}}</a>
              </li>
            </div>
          </template>
          <template slot="right-section"  v-if="localCount > 0">
            <div id="NotificationData" class="NotificationDetailBlock">
              <!-- Tab panes -->
              <div class="tab-content">
                <div class="tab-pane fade in active" id="Today">
                  <div class="ND-Cont">
                    <!-- <h2>{{notificationTitle}}</h2> -->
                    <div
                      class="dynamic-scroll-auto-height ND-Cont-scroll"
                      style="height:100%; overflow: auto;"
                    >
                      <template>
                        <div @click="onNotificationClick(n)"
                          class="ND-ContList"
                          :class="{'unread': !n.IsRead}"
                          v-for="(n, index) in notificationList"
                          :key="index"
                        >
                          <div class="NDContList-Pic">
                            <img
                              class="img-circle Hnotification-img"
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/noimage.svg`"
                              alt="NotificationPic"
                            >
                          </div>
                          <div class="NDContList-Cont">
                            <label>
                              <small>
                                <a href="javascript:;" v-html="n.Description"></a>
                              </small>
                            </label>

                            <span style="color:#656665">
                              <img style="width: 12px;margin-right:6px;color:#656665" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_timestamp.svg`"/>
                              {{n.CreatedDateTime | humantime}}
                            </span>
                          </div>
                          <a
                            href="javascript:;"
                            @click.stop="toggleReadStatus(n.Id, n.IsRead)"
                            class="marks__as__read"
                            v-if="!n.IsRead"
                          >Mark as Read</a>
                          <a
                            href="javascript:;"
                            @click.stop="toggleReadStatus(n.Id, n.IsRead)"
                            class="marks__as__read"
                            v-else
                          >Mark as Unread</a>
                          <div class="clearfix"></div>
                        </div>
                        <div class="text-center" v-if="showLoadMore">
                          <ob-spinner v-if="isLoading"></ob-spinner>
                          <a href="javascript:;" v-else @click="loadMore" style="display: block;padding:2%;">Load More</a>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
          </template>
          <template slot="right-section-empty" v-else >
            <div class="MT-Content-table">
              <div class="MT-Content">
                <div style="margin-bottom: 20px;"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_empty_alerts.svg`"></div>
                <div>You don't have any notifications for this period</div>
              </div>
            </div>
          </template>
        </ob-layout>
      </div>
    </div>
  </base-layout>
</template>
<script>
import c from '@/components/Core/constants.js'
export default {
  data() {
    return {
      notificationList: [],
      filterType: "Today",
      pageNumber: 0,
      pageSize: 10,
      fromDate: "",
      toDate: "",
      notificationTitle: "",
      showLoadMore: false,
      isLoading: false,
      List:[]
    };
  },

  computed: {
    localCount()
    {
     return this.notificationList.length
    },
    notificationCount() {
      return this.$store.getters.getUnreadNotificationsCount
    },
    notificationFilter() {
      switch (this.filterType) {
        case "Today":
          this.fromDate = moment()
            .utc()
            .format("MM/DD/YYYY");
          this.toDate = moment()
            .utc()
            .format("MM/DD/YYYY");
          this.notificationTitle = "Today's Notifications";
          break;
        case "CurrentWeek":
          this.fromDate = moment()
            .subtract(7, "d")
            .utc()
            .format("MM/DD/YYYY");
          this.toDate = moment()
            .utc()
            .format("MM/DD/YYYY");
          this.notificationTitle = "This Week's Notifications";
          break;
        case "CurrentMonth":
          this.fromDate = moment(1, "DD").format("MM/DD/YYYY");
          this.toDate = moment()
            .utc()
            .format("MM/DD/YYYY");
          this.notificationTitle = "This Month's Notifications";
          break;
        case "PreviousMonth":
          var previousMonth = moment()
            .subtract(1, "M")
            .utc();
          var fromDate = moment([
            previousMonth.format("YYYY"),
            previousMonth.format("MM") - 1,
            1
          ]);
          this.fromDate = fromDate.format("MM/DD/YYYY");
          this.toDate = fromDate
            .add(1, "M")
            .subtract(1, "d")
            .format("MM/DD/YYYY");
          this.notificationTitle =
            "Notifications from " + this.previousMonthLabel;
          break;
        case "PreviousMonth1":
          var previousMonth = moment()
            .subtract(2, "M")
            .utc();
          var fromDate = moment([
            previousMonth.format("YYYY"),
            previousMonth.format("MM") - 1,
            1
          ]);
          this.fromDate = fromDate.format("MM/DD/YYYY");
          this.toDate = fromDate
            .add(1, "M")
            .subtract(1, "d")
            .format("MM/DD/YYYY");
          this.notificationTitle =
            "Notifications from " + this.previousMonth1Label;
          break;
        case "PastSixMonths":
          this.fromDate = moment()
            .subtract(6, "M")
            .utc()
            .format("MM/DD/YYYY");
          this.toDate = moment()
            .utc()
            .format("MM/DD/YYYY");
          this.notificationTitle = "Notifications from Past 6 Months";
          break;
        case "CurrentYear":
          var currentYear = moment().format("YYYY");
          this.fromDate = moment([currentYear, 1, 1])
            .utc()
            .format("MM/DD/YYYY");
          this.toDate = moment()
            .utc()
            .format("MM/DD/YYYY");
          this.notificationTitle = "This Year's Notifications";
          break;
        case "PreviousYear":
          var previousYear = moment()
            .subtract(1, "y")
            .utc();
          this.fromDate = moment([previousYear.format("YYYY"), 0, 1]).format(
            "MM/DD/YYYY"
          );
          this.toDate = moment([previousYear.format("YYYY"), 11, 31]).format(
            "MM/DD/YYYY"
          );
          this.notificationTitle =
            "Notifications from " + this.previousYearLabel;
          break;
        case "PreviousYear1":
          var previousYear = moment()
            .subtract(2, "y")
            .utc();
          this.fromDate = moment([previousYear.format("YYYY"), 0, 1]).format(
            "MM/DD/YYYY"
          );
          this.toDate = moment([previousYear.format("YYYY"), 11, 31]).format(
            "MM/DD/YYYY"
          );
          this.notificationTitle =
            "Notifications from " + this.previousYear1Label;
          break;
        case "PreviousYear2":
          var previousYear = moment()
            .subtract(3, "y")
            .utc();
          this.fromDate = moment([previousYear.format("YYYY"), 0, 1]).format(
            "MM/DD/YYYY"
          );
          this.toDate = moment([previousYear.format("YYYY"), 11, 31]).format(
            "MM/DD/YYYY"
          );
          this.notificationTitle =
            "Notifications from " + this.previousYear2Label;
          break;
        default:
          this.fromDate = moment()
            .utc()
            .format("MM/DD/YYYY");
          this.toDate = moment()
            .utc()
            .format("MM/DD/YYYY");
          this.notificationTitle = "Today's Notifications";
          break;
      }
      return {
        SearchWord: "",
        PageNumber: this.pageNumber,
        PageSize: this.pageSize,
        FromDate: this.fromDate,
        ToDate: this.toDate,
        Type : this.filterType,
        IsViewAllPage : true
      };
    },
    previousMonthLabel() {
      return moment()
        .subtract(1, "M")
        .format("MMMM YYYY");
    },
    previousMonth1Label() {
      return moment()
        .subtract(2, "M")
        .format("MMMM YYYY");
    },
    previousYearLabel() {
      return moment()
        .subtract(1, "Y")
        .format("YYYY");
    },
    previousYear1Label() {
      return moment()
        .subtract(2, "Y")
        .format("YYYY");
    },
    previousYear2Label() {
      return moment()
        .subtract(3, "Y")
        .format("YYYY");
    },
    hasUnreadNotification() {
      let index = this.notificationList.findIndex(n => n.IsRead == false);
      if (index == -1) {
        return false;
      } else {
        return true;
      }
    }
  },
  created() { 
    this.fetch();

     this.interval = setInterval(() => {
         this.notificationList = [];
         this.notificationList = this.List;
     }, 1000);
  },
  watch: {
    localCount(v)
    {
      var x = document.getElementsByClassName("fixedHeight");
      if(v > 6 )
      {
        x[0].style.height = "510px";
      }
      else{
        x[0].style.height = null;
      }
    },
    filterType() {
      this.fetch();
    }
  },
  methods: {
    onNotificationClick(data){
      if(!data.IsRead){
        this.toggleReadStatus(data.Id , data.IsRead);
      }
      let url = "";
      if(data.Name == "Form I-983") {
        url = `/employee/form-i983`
      }
      else if(data.Name == "Task"){
       if(data.ActivityLog.ReceiverObject.Type == "Supervisor")  {
         let reportingEmpId = data.ActivityLog.ActionObject.CreatedBy.Id
          if(data.ActivityLog.ActivityType == "TaskDeleted"){
              url = `${c.APPLICATIONBASEURL}/ReportingEmployees/employee-tasks-trainee?EmployeeId=${reportingEmpId}&from=ReportingEmployee`
            }
         else{
              let TaskId = data.ActivityLog.ActionObject.Id
              url = `${c.APPLICATIONBASEURL}/employee-tasks-details/${TaskId}?EmployeeId=${reportingEmpId}&from=ReportingEmployee&isListview=true`;
          }
       }
       else{
         if(data.ActivityLog.ActivityType == "TaskDeleted"){
            url = `/employee-tasks/`
          }
         else{
            let TaskId = data.ActivityLog.ActionObject.Id
            url = `${c.APPLICATIONBASEURL}/employee-tasks-details/${TaskId}`;
         }

       }
       
      }
      else if(data.Name == "Policy Documents"){
        url = `/leave-policy`
      }
      else if(data.Name == "Holiday List"){
        url = `/holiday-list`
      }
      else if(data.Name == "Timesheets" || data.Name == "LeaveSettings" || data.Name == "Leave"){
        var fromDate = data.ActivityLog.ActionObject.Name;
        var email = data.ActivityLog.ActionObject.CreatedBy.Email;
        var empId = data.ActivityLog.ActionObject.CreatedBy.Id;

        if(data.NotificationType == "TimesheetRejected")
        {  
          if(empId == this.loggedInUserObj.empId)   
          {
          url = `/evaluation`
          } 
          else{  
          url = `/ReportingEmployees/employee-evaluation-trainee?EmployeeId=${empId}`
          }
        }
        else if(empId == this.loggedInUserObj.empId){
          url = `/my-timesheets?calenderDate=${fromDate}`
        }else{
          url = `/employer-timesheets?searchText=${email}&calenderDate=${fromDate}`
        }
      }
      else if(data.Name == "Project"){
          url = `/employee/projects`
        }
      else if(data.Name == "Personnel File"){
          url = `/employee`
      }

      if(url != "") {
        window.open(url, "_blank")
      }
    },
    fetch() {
      this.$loading("Loading...");
      this.pageNumber = 0;
      var orgId =  this.loggedInUserObj != null ? this.loggedInUserObj.orgId : "";
      ajax.put(
        `Notification/List?empOrgId=${orgId}`,
        this.notificationFilter,
        res => {
          let list = res.data.Notifications;
          if (list.length < parseInt(this.pageSize, 10)) {
            this.showLoadMore = false;
          } else {
            this.showLoadMore = true;
          }
          this.List = list;
          this.notificationList = list;
          this.$loading("Loading...").close();
        }
      );
    },
    markAllRead() {
      this.$loading("Marking all as read...");
      ajax.post(
        `/Notifications/UpdateNotificationStatusforAll?updateStatus=true`,
        {},
        res => {
            this.notificationList.forEach(n => {
                Vue.set(n, "IsRead", true);
            })
          this.$loading("Marking all as read...").close();

        }
      );
    },
    toggleReadStatus(notificationId, IsRead) {
      let notificationCount = this.$store.getters.getUnreadNotificationsCount;
      if(IsRead == false) {
        ajax.post(
          `/Notifications/MarkNotificationAsRead?notificationId=${notificationId}`,
          {},
          res => {
            let index = this.notificationList.findIndex(
              n => n.Id == notificationId
            );
            if (index != -1) {
              Vue.set(this.notificationList[index], "IsRead", true);
            }

            notificationCount--;
            this.$store.commit('updateUnreadNotificationsCount', notificationCount);
          }
        );
      } else {
        ajax.post(
          `/Notification/MarkNotificationAsUnRead?notificationId=${notificationId}`,
          {},
          res => {
            let index = this.notificationList.findIndex(
              n => n.Id == notificationId
            );
            if (index != -1) {
              Vue.set(this.notificationList[index], "IsRead", false);
            }

            notificationCount++;
            this.$store.commit('updateUnreadNotificationsCount', notificationCount);
          }
        );
      }
    },
    loadMore() {
      this.isLoading = true;
      this.pageNumber = this.pageNumber + 1;
      ajax.put(
        `Notification/List?empOrgId=${this.loggedInUserObj.orgId}`,
        this.notificationFilter,
        res => {
          let list = res.data.Notifications;
          if (list.length < parseInt(this.pageSize, 10)) {
            this.showLoadMore = false;
          } else {
            this.showLoadMore = true;
          }
          this.notificationList.push.apply(this.notificationList, list);
          this.isLoading = false;
        }
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.span-color{
  background: #FED4DE;
  color: #DD3D64;
  border-radius: 10px;
  padding: 0px 12px;
  font-weight: 600;
  top:20px;
}
.NotificationTabs > .active {
  background: #f0f7ff !important;
  border-left: 3px solid #59a2e7 !important;
  color: #337ab7 !important;
  .filter_type{
    color: #337ab7 !important;
  }
}
.NotificationTabs li{
  float: none !important;
    display: block;
    list-style-type: none !important;
    font-weight: 600;
    cursor: pointer;
    padding: 14px !important;
}
.NDContList-Cont label small a{
  color:#193360;
}
.filter_type{
  margin-left:10px;
}
.MT-Content-table{
  height:500px;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Notification.vue